import React from 'react';
import { FormattedMessage } from 'react-intl';

import LogoutMutation from 'components/mutations/LogoutMutation';
import { MOBILE_TERMINAL_ID_STORAGE_KEY, MOBILE_TERMINAL_SERIAL_NO_STORAGE_KEY } from 'constants/user';

import { StyledButton } from './Logout.styles';

const Logout = () => {
  const cleanup = () => {
    localStorage.removeItem(MOBILE_TERMINAL_ID_STORAGE_KEY);
    localStorage.removeItem(MOBILE_TERMINAL_SERIAL_NO_STORAGE_KEY);
  };

  return (
    <LogoutMutation>
      {({ logout, loading }) => (
        <StyledButton
          loading={loading}
          onClick={() => {
            cleanup();
            logout();
          }}
          disabled={loading}
          data-cy="logout-button"
        >
          <FormattedMessage id="logout.buttonText" />
        </StyledButton>
      )}
    </LogoutMutation>
  );
};

Logout.propTypes = {};

export default Logout;
